import { doMutation } from "../../core-module/util/graphqlHelper";
import { apolloClient } from "@/plugins/vue-apollo";
import {
  filterEmptyLocalisedValues,
  filterEmptyMediaUrls,
} from "@/app/core-module/util/coreHelper";

const updateQuizContentsCache = ({
  quizContent,
  variables,
  isDelete = false,
}) => {
  try {
    if (quizContent) {
      const cacheKey = {
        query: require("../api/query/getQuizContents.gql"),
        variables: variables,
      };

      const cachedData = apolloClient.readQuery(cacheKey);

      if (cachedData?.getQuizContents) {
        const existingIndex = cachedData.getQuizContents.quizContents.findIndex(
          x => x._id === quizContent._id
        );

        if (isDelete) {
          if (existingIndex >= 0) {
            cachedData.getQuizContents.quizContents.splice(existingIndex, 1);
          }
        } else {
          if (existingIndex >= 0) {
            cachedData.getQuizContents.quizContents[existingIndex] =
              quizContent;
          } else {
            cachedData.getQuizContents.quizContents.unshift(quizContent);
          }
        }

        apolloClient.writeQuery({ ...cacheKey, data: cachedData });
      }
    }
  } catch (e) {
    // console.log(
    //   "createOrUpdateQuizContent.updateQuizContentsCache:exception:",
    //   e.message
    // );
  }
};

const getQuizContentInput = quizContent => {
  const input = {
    _id: quizContent._id,
  };

  if (quizContent.title) {
    const localisedTitles = filterEmptyLocalisedValues(quizContent.title) ?? [];
    if (localisedTitles.length) input.title = localisedTitles;
  }

  if (quizContent.description) {
    input.description =
      filterEmptyLocalisedValues(quizContent.description) ?? [];
  }

  if (quizContent.quizContentImages) {
    const images = filterEmptyMediaUrls(quizContent.quizContentImages);
    if (images.length) input.images = images;
  }

  if (quizContent.quiz) {
    quizContent.quiz.questionAnswers = quizContent.quiz.questionAnswers.map(
      (questionAnswer, questionAnswerIndex) => {
        return {
          _id: questionAnswer._id,
          question: filterEmptyLocalisedValues(questionAnswer.question) ?? [],
          choices: questionAnswer.choices?.map(choice => {
            return {
              key: choice.key,
              value: filterEmptyLocalisedValues(choice.value) ?? [],
            };
          }),
          answerKey: questionAnswer.answerKey,
          mark: questionAnswer.mark,
          displayPosition: questionAnswerIndex, //questionAnswer.displayPosition,//removed for dragging,
        };
      }
    );

    input.quiz = {
      timeOut: quizContent.quiz.timeOut,
      passMark: quizContent.quiz.passMark,
      retryCount: quizContent.quiz.retryCount,
      questionAnswers: quizContent.quiz.questionAnswers,
      questionsDisplayedCount: quizContent.quiz.questionsDisplayedCount,
    };
  }

  return input;
};

export const createOrUpdateQuizContent = quizContent => {
  const mutation = require("../api/mutation/createOrUpdateQuizContent.gql");
  const variables = { input: getQuizContentInput(quizContent) };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      updateQuizContentsCache({
        quizContent: data?.createOrUpdateQuizContent,
        variables: { pageInput: { skip: 0, limit: 0 } },
      });

      return { data: data.createOrUpdateQuizContent };
    } else if (error) return { error: JSON.stringify(error) };
  });
};

export const deleteQuizContent = id => {
  const mutation = require("../api/mutation/deleteQuizContent.gql");
  const variables = { id };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      updateQuizContentsCache({
        quizContent: data?.deleteQuizContent,
        variables: { pageInput: { skip: 0, limit: 0 } },
        isDelete: true,
      });

      return { data: data.deleteQuizContent };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
